// @flow
import * as ActionTypes from 'constants/ActionTypes';

const initialState = {
  serviceError: "",
  serviceCode: 200,
  reqStatus: "",
  isLoading: false,
  systemUsage: {
    total_generations: 0,
    limit: 10000,
    remaining: 10000,
    percentage_used: "0.00%",
    status: "active",
  },
};

export default function (state: Object = initialState, action: Object) {
  switch (action.type) {
    case ActionTypes.ADMIN_GET_SYSTEM_USAGE_START: {
      return {
        ...state,
        isLoading: true,
        reqStatus: action.type,
        serviceError: "",
      };
    }

    case ActionTypes.ADMIN_GET_SYSTEM_USAGE_SUCCESS: {
      return {
        ...state,
        isLoading: false,
        reqStatus: action.type,
        serviceError: "",
        systemUsage: action.payload,
      };
    }

    case ActionTypes.ADMIN_GET_SYSTEM_USAGE_FAILURE: {
      return {
        ...state,
        isLoading: false,
        reqStatus: action.type,
        serviceError: action.payload,
      };
    }

    default:
      return state;
  }
}
